<template>
  <div class="page-index">
    <router-view />
  </div>
</template>
<script>
import HPanel from "@/components/HPanel";
import MarketBar from "@/views/frontViews/components/marketBar";
import FrontSideBar from "@/views/frontViews/components/frontSideBar";
import store from "@/store";
export default {
  name: "service",
  data() {
    return {
      user: store.getters.user,
      login: store.getters.user.hsid ? true : false,
      nav: 3,
      nickName: this.$store.state.user.user.hideNickName,
      cumbList: [],
      searchText: ""
    };
  },
  watch: {
    $route(to, from) {
      this.cumbList = this.$route.matched;
    }
  },
  created() {
    // let nikeName = store.getters.user.nike_name;
    // if(nikeName){
    //     //nikeName=$.trim(r.nikeName);
    //     if(/^1[3|4|5|7|8]\d{9}$/.test(nikeName) || /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(nikeName)){
    //       let str1 = nikeName.substring(0,3);
    //       let str2 = nikeName.substring(nikeName.length-4,nikeName.length);
    //       nikeName=str1+"****"+str2;
    //     }
    // }else{
    //     nikeName=store.getters.user.hsid;
    //     if(nikeName){
    //       let str1 = nikeName.substring(0,3);
    //       let str2 = nikeName.substring(nikeName.length-4,nikeName.length);
    //       nikeName=str1+"****"+str2;
    //     }
    // }
    // this.nickName = nikeName;
  },
  mounted() {
    this.cumbList = this.$route.matched;
  },
  methods: {
    goLogin() {
      //this.$router.push({ path: '/login' })
      localStorage.setItem("backUrl", window.location.href);
      this.$goLoginUrl();
    },
    goConsole() {
      if (this.login) {
        window.location.href = "/cloud/open/serviceapply/myServicePage.html";
      } else {
        localStorage.setItem("backUrl", window.location.href);
        this.$goLoginUrl();
      }
    },
    goRegister() {
      this.$registerFun();
    },
    //转到搜索页
    goSearch() {
      window.location.href =
        "/openplat-front/searchResult?content=" + encodeURIComponent(this.searchText);
    }
  },
  components: {
    MarketBar,
    FrontSideBar
  }
};
</script>
<style lang="scss" scoped>
// .cursor-pointer{
//   cursor:pointer;
// }
.page-index {
  // min-height: 100vh;
  background: #f3f4f5;
}
.hs-topbar {
  /**max-width:1200px;**/
  margin: 0 auto;
  background: #fff;
}
.hs-topbar-header {
  height: 70px;
  line-height: 70px;
  width: 1200px;
  margin: 0 auto;
  display: table;
  word-spacing: -1em;
}
.header-item {
  display: inline-block;
  cursor: pointer;
  vertical-align: middle;
}
.logo-wrapper {
  height: 100%;
}
.logo-wrapper img {
  width: 165px;
  height: 35px;
  vertical-align: middle;
}
.nav-text-split {
  padding: 0 14px 0 10px;
  /**height:14px;**/
}
.nav-text {
  color: #333;
  font-size: 16px;
}
.search-wrapper {
  margin-left: 61px;
  height: 35px;
  position: relative;
  .search-icon {
    width: 15px;
    height: 15px;
    position: absolute;
    background: url(../../assets/search-icon.png) center center no-repeat;
    left: 13px;
    top: 10px;
  }
}
.search-wrapper input {
  width: 380px;
  height: 35px;
  line-height: 35px;
  border: 2px solid #00abf0;
  text-indent: 37px;
  vertical-align: top;
}
input:focus {
  outline-offset: 0;
  outline: none;
}
.search-btn {
  background: #00abf0;
  width: 72px;
  height: 35px;
  line-height: 35px;
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.33px;
  text-align: center;
}
.h-l-wrapper {
  float: left;
}
.h-r-wrapper {
  float: right;
}
.h-r-wrapper .function-text {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.33px;
  margin-right: 35px;
  &:hover {
    color: #0ae;
  }
}
.h-r-wrapper .header-item:last-child .function-text {
  margin-right: 0;
  vertical-align: middle;
  max-width: 72px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.h-r-wrapper .function-btn {
  background: #00abf0;
  width: 120px;
  height: 35px;
  line-height: 35px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.33px;
  text-align: center;
}
.nav-wrapper {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.nav-wrapper .nav-item {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.33px;
  margin: 13px 61px 13px 0;
}
.nav-wrapper .nav-item-active {
  color: #0ae;
  font-weight: bold;
}
.breadcrumb-wrapper {
  width: 1200px;
  margin: 12px auto 11px auto;
  .h-breadcrumb > span:last-child {
    color: #0ae;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/service.vue